function hulkappsModalFormInit() {
  let is_form_submit = false;
  const modal = document.querySelector('.hulk-modal');
  const exitModal = document.querySelector('.hulk-modal span.close');

  function showModal() {
    modal.style.display = 'flex';
    document.querySelector('html').classList.add('prevent_scroll');
  }

  function hideModal() {
    modal.style.display = 'none';
    document.querySelector('html').classList.remove('prevent_scroll');
  }

  exitModal.addEventListener('click', hideModal);

  document.addEventListener('click', (e) => {
    if (e.target == modal) hideModal;
  })


  document.body.addEventListener('click', (e) => {
    if (e.target.closest('button[name="checkout"], input[name="checkout"]') && !is_form_submit) {
      e.preventDefault();
      checkCart();
      console.log('Checking cart - Default prevented');
    }
  }, !0);

  async function checkCart() {
    console.log('Inside')
    let foundTags = new Array();
    const hulkForm = document.querySelector('#hulk-modal .pxFormGenerator iframe');

    await fetch('/cart.js')
      .then(res => res.json())
      .then(cart => cart.items.forEach((item) => {
        if (item.properties && item.properties.hasOwnProperty('_approval_needed')) {
          foundTags.push(item.properties['_approval_needed']);
          console.log('Product has approval tag');
          hulkForm.contentWindow.postMessage({ products: foundTags }, '*');
        }
      }))

    if (foundTags.length > 0) {
      showModal();
    } else {
      is_form_submit = true;
      e.target.click();
    }
  }
}


document.addEventListener('DOMContentLoaded', hulkappsModalFormInit);

window.addEventListener("message", (event) => {
  if (event.data === "close_modal") {
    const modal = document.querySelector('.hulk-modal');
    modal.style.display = 'none';
  }
});